import RecentCharacterizationSummaryWidget from './RecentCharacterizationSummaryWidget'

export default RecentCharacterizationSummaryWidget
